module.exports = __webpack_public_path__ + "static/media/Josh-Johnson.d1cabf85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Josh-Johnson.jpg
// module id = 378
// module chunks = 0